import React from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import { connect } from "react-redux";
import SalaryForm from './components/SalaryForm';
import EmployeeProfile from "../components/EmployeeProfile";
import avatar from "assets/img/avatars/user.png";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";

const ViewEmployeeSalary = () => {
	const { employeeId, salarieId } = useParams();

	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					<div className="mb-4">
						<EmployeeProfile avatar={avatar} withDesignation={true} recordId={employeeId}/>
					</div>
					<div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
						<SectionHeader title="Salary Info">
							<PopupButton id="edit_salary" title="Edit Salary" label="Edit" >
								<SalaryForm recordId={salarieId}  employeeId={employeeId} mode="edit"/>
							</PopupButton>
						</SectionHeader>
						<SalaryForm recordId={salarieId} employeeId={employeeId} mode="view"/>
					</div>	
				</Card>
	      	</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployeeSalary);